import { Injectable } from "@angular/core";
import heic2any from "heic2any";

@Injectable({ providedIn: 'root' })
export class ImageUtility {

    base64ToBlob = async (base64: string): Promise<Blob> => {
        return await (await fetch(base64)).blob();
    }

    async getFileFromBlob(blob: Blob): Promise<string | ArrayBuffer | null> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
            reader.readAsDataURL(blob);
        });
    }

    getFileFromBlobAsync(blob: Blob): Promise<string | ArrayBuffer | null> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            try {
                reader.onload = async () => {
                    resolve(reader.result);
                }
            } catch (err) {
                reject(err);
            }
            reader.readAsDataURL(blob);
        });
    }

    heicToJpg = (blob: Blob): Promise<Blob> => {
        return new Promise((resolve, reject) => {
            heic2any({ blob })
                .then(result => resolve(result as Blob))
                .catch(e => reject(e));
        });
    }

    isImage = (fileName?: string): boolean => {
        if (fileName == null) {
            return false;
        }

        return fileName.match(/\.(jpg|jpeg|png|gif|heic)$/i) !== null;
    }

    isImageFileType = (fileType: string): boolean => {
        return ['jpg', 'jpeg', 'png', 'gif', 'heic'].includes(fileType.toLowerCase());
    }

    isHeicFile = (filename?: string): boolean => {
        if (!filename) {
            return false;
        }

        return filename.match(/\.(heic)$/i) !== null;
    }
}